// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4366":"css/admin-app.6678","5290":"css/app.6678"}[chunkId] + ".css";
};